/* istanbul ignore file */
import React, { useState, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import '../styles/header.css';
import '../components.css';
import { useIsDesktop, useIsTablet } from '../../hooks/breakpoints';
import './styles.css';
import { ess } from '../OnBoarding/ess'
import { useAppState } from '../../contexts/appState'
import configMenu from '../Sidebar/config.js';
import { raiseGAEventForVaccination } from '../../utils/network'
import config from '../../config.json'

export default () => {
  const [{ menu, menuDrawer }, dispatch] = useAppState()
  const [childNavigation, setChildNavigationStatus] = useState(false);
  const urlParams = new URLSearchParams(window.location.search);
  const [parentKey, setParentKey] = useState();
  const [children, setChildren] = useState([]);
  const isDesktop = useIsDesktop();
  const isTablet = useIsTablet();
  const history = useHistory();
  const query = useQuery()

  let covidVaccinationUrls = configMenu.map(item => item.url)
  configMenu.filter(item => item.nodes && item.nodes.length > 0).forEach(item => {
    item.nodes.forEach(nodeItem => {
      covidVaccinationUrls.push(nodeItem.url);
    })
  })
  useEffect(() => {
    const path = history.location.pathname;
    const item = configMenu.find(item => path.includes(item.url));

    if (item) {
      onClickHandler(item);
      if (!item.url.includes("http:")) {
        const hasChild = path.split('/').length > 2

        if (hasChild) {
          const childItem = item.nodes.find(item => path === item.url);
          if (childItem) {
            onClickHandler(childItem);
          }
        }
      }
    }
  }, [history.location.pathname, menu]);

  function useQuery() {
    return new URLSearchParams(useLocation().search)
  }

  const onClickHandler = (item) => {
    if (query.get('reschedule')) {
      query.delete('reschedule')
    }
    const path = history.location.pathname;
    if (item && item.nodes && item.nodes.length !== 0) {
      history.push(`${item.nodes[0].url}?${query.toString()}`)
      setParentKey(item.key);
      setChildren(item.nodes);
      setChildNavigationStatus(true);
    }
    else {
      if (item.url.split("/").length < 3) {
        setChildren();
        setChildNavigationStatus(false);
      }
      if (item.url.includes("http")) {
        const win = window.open(item.url, "_blank");
        win.focus();
      } else {
        hideMenu();
        history.push(`${item.url}?${urlParams.toString()}`);
      }
    }
  }
  const hideMenu = () => {
    dispatch({ type: 'UPDATE_MENUDRAWER_STATUS', menuDrawerStatus: false })
  }
  const renderMobile = () => {

    const goHome = () => {
      ess().isFromEss ? window.close() : history.push('/');
    };

    return <>
      <div className="mobile-container" style={{ left: `${menuDrawer ? '0' : '-255'}px` }}>
        <div className="logo-container">
          <button className="logo-btn">
            <img style={{ height: '1.85em' }} src="/icons/jioHHInverted.svg" alt="Jio Health Hub" />
          </button>
        </div>
        <nav className="mobile-parent" style={{ paddingTop: '1rem' }} role="navigation" aria-label="Application menu">
          {configMenu.map((item, index) => item.display && (
            <div key={item.key}>
              <div
                className={`mobile-parentItem ${history.location.pathname.includes(item.url) ? 'mobile-parentItem-active' : ''}`}
                key={item.key}
                onClick={() => { onClickHandler(item) }}
              >
                <img src={`${history.location.pathname.includes(item.url) ? item.icon.selected : item.icon.unselected}`}></img>
                <div >{item.label}</div>
              </div>

              <nav className="mobile-child" style={{ display: `${childNavigation && parentKey === item.key ? 'block' : 'none'}` }} role="navigation" aria-label="Application sub-menu">
                {children && children.map((item, index) => item.display && (
                  <div
                    className={`mobile-childItem ${history.location.pathname.includes(item.url) ? 'mobile-childItem-active' : ''}`}
                    key={item.key}
                    onClick={() => { onClickHandler(item) }}
                  >
                    <div >{item.label}</div>
                  </div>)
                )}
              </nav>
            </div>
          ))}
        </nav>
      </div>
      {menuDrawer && <div className="overlay" onClick={() => hideMenu()}></div>}
    </>

  }

  const renderDesktop = () => (<>
    <nav className="parent" role="navigation" aria-label="Application menu">
      {configMenu.map((item, index) => item.display && (
        <div
          className={`parentItem ${history.location.pathname.includes(item.url) ? 'parentItem-active' : ''}`}
          key={item.key}
          onClick={() => {
            onClickHandler(item)
            const parentMenuLabel = item.url.split('/').length > 1 ? item.url.split('/')[1] : '';
            const ga = {
              new_Category: config.gaJioHealthHub,
              new_Action: config.gaMenuClick,
              new_Label: parentMenuLabel,
            }
            // raiseGAEventForVaccination({ ...ga });
          }}
        >
          <img src={`${history.location.pathname.includes(item.url) ? item.icon.selected : item.icon.unselected}`}></img>
          <div >{item.label}</div>
        </div>
      ))}
    </nav>
    {
      childNavigation && (
        <nav className="child" role="navigation" aria-label="Application sub-menu">
          {children && children.map((item, index) => item.display && (
            <div
              className={`childItem ${history.location.pathname.includes(item.url) ? 'childItem-active' : ''}`}
              key={item.key}
              onClick={() => {
                onClickHandler(item)
                const parentModule = item.url.split('/').length > 1 ? item.url.split('/')[1] : '';
                if (parentModule === 'my-vaccinations') {
                  const ga = {
                    new_Category: config.gaMyVaccination,
                    new_Action: item.label,
                    new_Label: config.gaClick,
                  }
                  // raiseGAEventForVaccination({ ...ga });
                }
                if (parentModule === 'book-appointment') {
                  const ga = {
                    new_Category: config.gaBookAppointment,
                    new_Action: item.label,
                    new_Label: config.gaClick,
                  }
                  // raiseGAEventForVaccination({ ...ga });
                }

              }}
            >
              <div >{item.label}</div>
            </div>)
          )}
        </nav>)
    }
  </>
  );
  return (
    (covidVaccinationUrls.includes(history.location.pathname) && menu ?
      <>{(isDesktop || isTablet) ? renderDesktop() : renderMobile()}</> :
      <></>
    )

  );
};

